/**
 * @file index.jsx
 * @author Daniel Aguirre
 * @description Card indicator
 */

// Dependencies
import PropTypes from 'prop-types';
import { CaretUpOutlined } from '@ant-design/icons';

function CardIndicator({ title, date, value, level, isHigh }) {
  return (
    <div
      className="flex flex-wrap justify-center float-left"
      style={{
        width: 155,
        height: 155,
        padding: 5,
        borderRadius: 10,
        color: isHigh ? 'white' : 'var(--color-baxterBlue)',
        backgroundColor: isHigh ? 'var(--color-stage3b)' : '#e3e8ed'
      }}>
      <div className="mb-2 w-full">
        {title} <br />
        {date}
      </div>
      <div className="mb-0" style={{ fontSize: 30, fontWeight: 'bold' }}>
        {value}%
      </div>
      <div className="w-full space-x-6" style={{ fontSize: 20 }}>
        <strong className="align-text-top">{level}</strong>
        {isHigh && <CaretUpOutlined />}
      </div>
    </div>
  );
}

/**
 * Component definition of proptypes.
 */
CardIndicator.propTypes = {
  title: PropTypes.string,
  date: PropTypes.string,
  value: PropTypes.number,
  level: PropTypes.string,
  isHigh: PropTypes.bool
};

export default CardIndicator;
